import React, { Fragment } from "react";
import GmailIcon from "../../../lib/components/Icons/GmailIcon";
import LocationIcon from "../../../lib/components/Icons/LocationIcon";
import PrivacyLockIcon from "../../../lib/components/Icons/PrivacyLockIcon";
import Footer from "../common/Footer";
import PageTitleContainer from "../common/PageTitleContainer";

export default function PrivacyPolicyComponent() {
  return (
    <>
      <main className="flex min-h-screen flex-col justify-between">
        <section className="flex w-full items-center justify-center">
          <PageTitleContainer title="Privacy Policy | Nbyula" />
          <div className="mt-16 w-11/12 sm:w-200">
            <h1 className="static top-0 left-0 font-sans text-xl font-bold text-secondary sm:text-4xl">
              Privacy policy
            </h1>
            <div className="mt-8 flex">
              <div className="h-72 w-96">
                <p className="font-serif text-sm text-secondary-dark-200 sm:text-base">
                  This privacy policy has been compiled to better serve those
                  who are concerned with how their 'Personally identifiable
                  information' (PII) is being used online. PII, as used in US
                  privacy law and information security, is information that can
                  be used on its own or with other information to identify,
                  contact, or locate a single person, or to identify an
                  individual in context. Please read our privacy policy
                  carefully to get a clear understanding of how we collect, use,
                  protect or otherwise handle your Personally Identifiable
                  Information in accordance with our website.
                </p>
              </div>
              <div className="ml-24 hidden h-70 w-72 sm:inline-block">
                <PrivacyLockIcon />
              </div>
            </div>
            <h1 className="mt-16 font-serif text-sm font-semibold text-primary sm:text-base">
              Updated Dec 30, 2025
            </h1>
            <hr className="top-6 border border-solid border-stroke" />
            <div className="mt-12">
              <p className="font-serif text-base font-semibold text-secondary sm:text-lg">
                What personal information do we collect from the people that
                visit our blog, website or app?
              </p>
              <p className="mt-6 font-serif text-sm sm:text-base">
                When ordering or registering on our site, as appropriate, you
                may be asked to enter your name, email address, mailing address,
                phone number, credit card information, social security number or
                other details to help you with your experience.
              </p>
              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                How do we use your information?
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                Nbyula will make every possible effort to give you (the user)
                control of your data and its visibility through the privacy
                settings. Nbyula is a community-driven platform and users
                benefit from communal data sharing, for this reason, Nbyula
                retains the right to set a fair level of visibility of your data
                for the benefit of other nbyula users. You will able to view
                data of other users under the terms of fair data sharing
                guidelines of the platform. We may use the information we
                collect from you when you register, make a purchase, sign up for
                our newsletter, respond to a survey or marketing communication,
                surf the website, or use certain other site features in the
                following ways:
              </p>
              <ul>
                <li>
                  To personalize user's experience and to allow us to deliver
                  the type of content and product offerings in which you are
                  most interested.
                </li>
                <li>
                  <p>To improve our website in order to better serve you.</p>
                </li>
                <li>
                  <p>
                    To administer a contest, promotion, survey or other site
                    feature.
                  </p>
                </li>
                <li>
                  <p>To quickly process your transactions.</p>
                </li>
                <li>
                  <p>
                    To send periodic emails regarding your order or other
                    products and services.
                  </p>
                </li>
                <li>
                  <p>
                    To create and update your profile on Nbyula via data
                    provided directly or indirectly in a fashion to improve the
                    experience of the platform for you and other users. You will
                    have the control to edit and remove such data on the
                    platform. The user is solely responsible for the data shared
                    on the platform and Nbyula will not be liable for any misuse
                    of such data by the user or any third party.
                  </p>
                </li>
              </ul>
              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                How do we protect visitor information?
              </h4>

              <p className="mt-6 font-serif text-sm sm:text-base">
                We do not use vulnerability scanning and/or scanning to PCI
                standards. We use regular Malware Scanning.
              </p>
              <p className="font-serif text-sm sm:text-base">
                Your personal information is contained behind secured networks
                and is only accessible by a limited number of persons who have
                special access rights to such systems, and are required to keep
                the information confidential. In addition, all sensitive/credit
                information you supply is encrypted via Secure Socket Layer
                (SSL) technology.
              </p>
              <p className="font-serif text-sm sm:text-base">
                We implement a variety of security measures when a user enters,
                submits, or accesses their information to maintain the safety of
                your personal information.
              </p>
              <p className="font-serif text-sm sm:text-base">
                All transactions are processed through a gateway provider and
                are not stored or processed on our servers.
              </p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                Do we use 'cookies'?
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                Yes. Cookies are small files that a site or its service provider
                transfers to your computer's hard drive through your Web browser
                (if you allow) that enables the site's or service provider's
                systems to recognize your browser and capture and remember
                certain information. For instance, we use cookies to help us
                remember and process the items in your shopping cart. They are
                also used to help us understand your preferences based on
                previous or current site activity, which enables us to provide
                you with improved services. We also use cookies to help us
                compile aggregate data about site traffic and site interaction
                so that we can offer better site experiences and tools in the
                future.
              </p>
              <br />
              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                We use cookies to:
              </h4>
              <ul>
                <li>
                  <p className="mt-6 font-serif text-sm sm:text-base">
                    Understand and save user's preferences for future visits.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Compile aggregate data about site traffic and site
                    interactions in order to offer better site experiences and
                    tools in the future. We may also use trusted third party
                    services that track this information on our behalf.
                  </p>
                </li>
              </ul>
              <p></p>
              <p className="font-serif text-sm sm:text-base">
                You can choose to have your computer warn you each time a cookie
                is being sent, or you can choose to turn off all cookies. You do
                this through your browser (like Internet Explorer) settings.
                Each browser is a little different, so look at your browser's
                Help menu to learn the correct way to modify your cookies.
              </p>
              <br />
              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                If users disable cookies in their browser:
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                If you disable cookies off, some features will be disabled It
                will turn off some of the features that make your site
                experience more efficient and some of our services will not
                function properly. However, you can still place orders User
                sessions will not be available.
              </p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                Data Deletion
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                At Nbyula, we are committed to safeguarding your privacy and
                providing you with control over your personal information. If
                you wish to have your data deleted from our systems, please
                follow the instructions outlined below:
              </p>
              <ul className="mt-6 font-serif text-sm sm:text-base">
                <li>
                  <p className="font-semibold">1. Email Request:</p>
                  <p>
                    To initiate the data deletion process, please send an email
                    to our dedicated support team at support@nbyula.com. In the
                    subject line of your email, include "Data Deletion Request"
                    to ensure a prompt and efficient response. In the body of
                    the email, provide the necessary details to help us verify
                    your identity and locate your information in our systems.
                  </p>
                </li>
                <li className="mt-3">
                  <p className="font-semibold">2. Verification Process:</p>
                  <p>
                    To protect your privacy and ensure the security of your
                    data, we may need to verify your identity before proceeding
                    with the deletion request. This verification process is in
                    place to prevent unauthorized access and deletion of your
                    information.
                  </p>
                </li>
                <li className="mt-3">
                  <p className="font-semibold">
                    3. Information Required for Verification:
                  </p>
                  <p>
                    When submitting your data deletion request, please include
                    the following information in your email:
                    <p>- Full name</p>
                    <p>
                      - Email address and/or Mobile Number associated with your
                      account
                    </p>
                    <p>
                      - Any additional details that may assist in confirming
                      your identity
                    </p>
                  </p>
                </li>
                <li className="mt-3">
                  <p className="font-semibold">4. Timely Processing:</p>
                  <p>
                    We strive to process data deletion requests in a timely
                    manner, generally within 7 business days from the date of
                    receipt. However, the actual processing time may vary
                    depending on the complexity of the request and the volume of
                    requests we receive.
                  </p>
                </li>
                <li className="mt-3">
                  <p className="font-semibold">5. Confirmation of Deletion:</p>
                  <p>
                    Once your data has been successfully deleted from our
                    systems, we will send you a confirmation email. Please note
                    that certain residual data may still exist in our backup
                    systems for a limited period, as we adhere to
                    industry-standard practices for data retention. However,
                    this data will not be used for any purpose and will be
                    securely deleted in accordance with our retention policies.
                  </p>
                </li>
                <li className="mt-3">
                  <p className="font-semibold">6. Contact Information:</p>
                  <p>
                    For any questions or concerns regarding the data deletion
                    process or our privacy practices, you can contact our
                    support team at support@nbyula.com.
                  </p>
                </li>
              </ul>
              <p className="mt-6 font-serif text-sm sm:text-base">
                By using our services, you acknowledge and agree to the terms
                outlined in this Data Deletion section of our Privacy Policy. We
                reserve the right to update or modify this section periodically,
                and any changes will be reflected in the latest version of our
                Privacy Policy. It is your responsibility to review these terms
                regularly for any updates.
              </p>

              <br />
              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                Third Party Disclosure
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                We do not sell, trade, or otherwise transfer to outside parties
                your personally identifiable information unless we provide you
                with advance notice. This does not include website hosting
                partners and other parties who assist us in operating our
                website, conducting our business, or servicing you, so long as
                those parties agree to keep this information confidential. We
                may also release your information when we believe release is
                appropriate to comply with the law, enforce our site policies,
                or protect ours or others' rights, property, or safety.
              </p>
              <p className="font-serif text-sm sm:text-base">
                However, non-personally identifiable visitor information may be
                provided to other parties for marketing, advertising, or other
                uses.
              </p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                Third party links
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                Occasionally, at our discretion, we may include or offer third
                party products or services on our website. These third party
                sites have separate and independent privacy policies. We
                therefore have no responsibility or liability for the content
                and activities of these linked sites. Nonetheless, we seek to
                protect the integrity of our site and welcome any feedback about
                these sites.
              </p>
              <br />
              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                Google
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                Google's advertising requirements can be summed up by Google's
                Advertising Principles. They are put in place to provide a
                positive experience for users.
                <a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">
                  AdWords policies
                </a>
              </p>
              <p className="font-serif text-sm sm:text-base">
                We have not enabled Google AdSense on our site but we may do so
                in the future.
              </p>
              <br />

              <h4 className="text-secondarytext-base mt-9 font-serif font-semibold sm:text-lg">
                California Online Privacy Protection Act
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                CalOPPA is the first state law in the nation to require
                commercial websites and online services to post a privacy
                policy. The law's reach stretches well beyond California to
                require a person or company in the United States (and
                conceivably the world) that operates websites collecting
                personally identifiable information from California consumers to
                post a conspicuous privacy policy on its website stating exactly
                the information being collected and those individuals with whom
                it is being shared, and to comply with this policy.
                <a
                  href="http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf"
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary"
                >
                  - Read more
                </a>
              </p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                According to CalOPPA we agree to the following:
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                Users can visit our site anonymously
                <br />
                Once this privacy policy is created, we will add a link to it on
                our home page, or as a minimum on the first significant page
                after entering our website. Our Privacy Policy link includes the
                word 'Privacy', and can be easily be found on the page specified
                above.
              </p>
              <p className="font-serif text-sm sm:text-base">
                Users will be notified of any privacy policy changes:
              </p>
              <ul>
                <li>
                  <p className="font-serif text-sm sm:text-base">Via Email</p>
                </li>
              </ul>
              <p></p>
              <p className="font-serif text-sm sm:text-base">
                Users are able to change their personal information:
              </p>
              <ul>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    By logging in to their account
                  </p>
                </li>
              </ul>
              <p></p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                How does our site handle do not track signals?
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                We honor do not track signals and do not track, plant cookies,
                or use advertising when a Do Not Track (DNT) browser mechanism
                is in place.
              </p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                Does our site allow third party behavioral tracking?
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                It's also important to note that we do not allow third party
                behavioral tracking.
              </p>
              <br />

              <h4 className="mt-9 font-serif text-base font-semibold text-secondary sm:text-lg">
                COPPA (Children Online Privacy Protection Act)
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                When it comes to the collection of personal information from
                children under 13, the Children's Online Privacy Protection Act
                (COPPA) puts parents in control. The Federal Trade Commission,
                the nation's consumer protection agency, enforces the COPPA
                Rule, which spells out what operators of websites and online
                services must do to protect children's privacy and safety
                online.
              </p>
              <p className="font-serif text-sm sm:text-base">
                We do not specifically market to children under 13.
              </p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                Fair Information Practices
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                The Fair Information Practices Principles form the backbone of
                privacy law in the United States and the concepts they include
                have played a significant role in the development of data
                protection laws around the globe. Understanding the Fair
                Information Practice Principles and how they should be
                implemented is critical to comply with the various privacy laws
                that protect personal information.
              </p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                In order to be in line with Fair Information Practices we will
                take the following responsive action, should a data breach
                occur:
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                We will notify the users via email
              </p>
              <ul>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Within 1 business day
                  </p>
                </li>
              </ul>
              <p></p>
              <p className="font-serif text-sm sm:text-base">
                We also agree to the individual redress principle, which
                requires that individuals have a right to pursue legally
                enforceable rights against data collectors and processors who
                fail to adhere to the law. This principle requires not only that
                individuals have enforceable rights against data users, but also
                that individuals have recourse to courts or a government agency
                to investigate and/or prosecute non-compliance by data
                processors.
              </p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                CAN SPAM Act
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                The CAN-SPAM Act is a law that sets the rules for commercial
                email, establishes requirements for commercial messages, gives
                recipients the right to have emails stopped from being sent to
                them, and spells out tough penalties for violations.
              </p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                We collect your email address in order to:
              </h4>
              <p></p>
              <ul>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Send information, respond to inquiries, and/or other
                    requests or questions.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Market to our mailing list or continue to send emails to our
                    clients after the original transaction has occurred.
                  </p>
                </li>
              </ul>
              <p></p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                To be in accordance with CANSPAM we agree to the following:
              </h4>
              <ul>
                <li>
                  <p className="mt-6 font-serif text-sm sm:text-base">
                    NOT use false, or misleading subjects or email addresses.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Identify the message as an advertisement in some reasonable
                    way.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Include the physical address of our business or site
                    headquarters.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Monitor third party email marketing services for compliance,
                    if one is used.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Honor opt-out/unsubscribe requests quickly.
                  </p>
                </li>
                <li>
                  <p className="font-serif text-sm sm:text-base">
                    Allow users to unsubscribe by using the link at the bottom
                    of each email.
                  </p>
                </li>
              </ul>
              <p></p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                If at any time you would like to unsubscribe from receiving
                future emails, you can email us at
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                Follow the instructions at the bottom of each email. and we will
                promptly remove you from ALL correspondence.
              </p>
              <br />

              <h4 className="font-serif text-base font-semibold text-secondary sm:text-lg">
                Protocelestial Technologies Private Limited Honor Code
              </h4>
              <p className="mt-6 font-serif text-sm sm:text-base">
                As part of Protocelestial Technologies Private Limited's
                commitment to respect privacy, the company promises to adhere to
                the following code : 1. Never to share any details of
                users/subscribers with any third party without their explicit
                consent. 2. Allow users a forum/medium to voice their
                opinions/concerns/suggestions to improve the quality of data and
                correct any errors or omissions. 3. Not to involve any practices
                that will reduce or revoke the trust of our users and
                subscribers to the maximum possible extent of logic.
              </p>

              <h4 className="mt-6 font-serif text-base font-semibold text-secondary sm:text-lg">
                Contacting Us
              </h4>
              <p className="mt-6 font-serif text-sm text-secondary-dark-300 sm:text-base">
                If there are any questions regarding this privacy policy you may
                contact us using the information below.
              </p>
              <div className="mt-6 flex">
                <div>
                  <LocationIcon className="h-5 w-5 text-primary" />
                </div>
                <div className="h-32 w-80">
                  <p className="ml-5 font-serif text-base text-secondary">
                    Protocelestial Technologies Private Limited <br />
                    Unit No. B1, A Tower, 2nd Floor, Golden Enclave Corporate
                    Block, Old Airport Road, Bangalore, 560017.
                  </p>
                </div>
              </div>
              <div className="mt-4 flex">
                <div>
                  <GmailIcon className="h-5 w-5 text-primary" />
                </div>
                <div className="mb-20 ml-4 cursor-pointer font-serif text-sm text-primary sm:text-base">
                  <a href="mailto:hello@nbyula.com">hello@nbyula.com</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
}
